import { render, staticRenderFns } from "./SelectorInstrument.vue?vue&type=template&id=155652b2&scoped=true&"
import script from "./SelectorInstrument.vue?vue&type=script&lang=js&"
export * from "./SelectorInstrument.vue?vue&type=script&lang=js&"
import style0 from "./SelectorInstrument.vue?vue&type=style&index=0&id=155652b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155652b2",
  null
  
)

export default component.exports